import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'lock-selector',
    templateUrl: './lock-selector.component.html',
    styles: [`
        .dropdown-toggle {
            white-space: nowrap;
        }
        .dropdown-item {
            padding-left: 0.75rem;
        }
    `]
})
export class LockSelectorComponent {
    @Input() model: boolean;
    @Input() readonly = false;

    @Output() modelChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    onLock(): void {
        this.model = true;
        this.modelChange.emit(this.model);
    }

    onUnlock(): void {
        this.model = false;
        this.modelChange.emit(this.model);
    }
}
